import { type UseQueryResult, useQuery } from 'react-query';
import { CustomerOptionDto, CustomerSuccessOptionsAppserviceService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetCustomerSuccessRoleMapping = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
): UseQueryResult<Array<CustomerOptionDto> | undefined, unknown> => {
  const getCustomerSuccessRoleMapping = useQuery(
    ['getCustomerSuccessRoleMapping'],
    async () => {
      return await handleRequest(
        CustomerSuccessOptionsAppserviceService.getApiCustomerApiCustomerCustomerSuccessOptionsRoleMapping(
        )
      );
    },
  );
  return getCustomerSuccessRoleMapping;
};

export default useGetCustomerSuccessRoleMapping;
